import React from 'react';
import {ErrorBoundary} from '@shared/components/ui/ErrorBoundary';
import {Layout} from '@shared/components/layout/Layout';
import {AppRouter} from '@/router/AppRouter';
import './App.scss';
import {HelmetProvider} from "react-helmet-async";

const helmetContext = {};

const App: React.FC = () => {
    return (
        <ErrorBoundary>
            <HelmetProvider context={helmetContext}>
                <Layout>
                    <AppRouter/>
                </Layout>
            </HelmetProvider>
        </ErrorBoundary>
    );
};

export default App;
